import { render, staticRenderFns } from "./CrosswordPreview.vue?vue&type=template&id=2a1b500d&"
import script from "./CrosswordPreview.vue?vue&type=script&lang=js&"
export * from "./CrosswordPreview.vue?vue&type=script&lang=js&"
import style0 from "./CrosswordPreview.vue?vue&type=style&index=0&id=2a1b500d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports